export class PetRequest {
    pet_name: string;
    species: string;
    breed: string;
    dob: string;
    sex: string;
}
